import * as ConfigTypes from 'config/ConfigTypes';

export const clickOutSide = (ref, cb) => {
    const listener = (e) => {
        if (!ref.current || ref.current.contains(e.target)) {
            return;
        }
        cb();
    }
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
}

export const onKeyPress = (elementId, callback) => () => {
    let el = document.getElementById(elementId);
    if (el) el.onkeypress = (e) => {
        if (e.key === ConfigTypes.ENTER && e.shiftKey) return;
        else if (e.key === ConfigTypes.ENTER) callback(el);
    }
}

export const onFullScreenClick = (elementId, fullSrc) => () => {
    let elem = document.getElementById(elementId);
    elem.src = fullSrc;
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    }
    else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
    }
    else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
    }
    else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
    } else {
        console.log("LOGS: Fullscreen is not supported!");
    }

}

export const setScrollTop = (elId) => {
    if (elId) {
        let tabEl = document.getElementById(elId);
        if (tabEl) tabEl.scrollTo(0, 0);
    }
}